import React from "react";
import CommonInput from "../../../components/forms/CommonInput";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import CommonInputMask from "../../../components/forms/CommonInputMask";
import CommonSelect from "../../../components/forms/CommonSelect";
import {
  handleChange,
  handleChangeCheck,
  handleChangeNumeral,
  handleChangeUnmask,
} from "../../../helpers/handleFormChanges";
import CommonSwal from "../../../components/Swal/commonSwal";
import CommonCheckboxSimNao from "../../../components/forms/CommonCheckboxSimNao";
import CommonButton from "../../../components/buttons/CommonButton";
import { formataData, hoje } from "../../../helpers/mesesHelper";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import TabHelper from "../../../helpers/TabHelper";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function DadosPessoais({
  valuesHook,
  estados,
  municipios,
  cepApi,
  dependentes,
  tabHook,
  salvaColaborador,
  editavel,
  novoDependente,
  excluirDependente,
  retornar,
  admissao = false,
}) {
  const { values, setValues } = valuesHook;
  const { getCep, cepResponse } = cepApi;
  const { tabAtual, setTabAtual } = tabHook;
  const tiposDeficiencia = useTipos("tipos_deficiencia");
  const tiposDependente = useTipos("tipos_dependente");
  const tiposEstadoCivil = useTipos("tipos_estado_civil");
  const tiposEtnia = useTipos("tipos_etnia");
  const tiposGenero = useTipos("tipos_genero");
  const tiposGrauInstrucao = useTipos("tipos_grau_instrucao");
  const tiposNacionalidade = useTipos("tipos_nacionalidade");

  //Busca dados do CEP
  React.useEffect(() => {
    if (!values?.cep || values?.cep.length !== 8) return;
    try {
      getCep(values.cep);
    } catch (e) {
      CommonSwal({
        title: "Oops!",
        text: "Ocorreu algum erro inesperado, se o problema persistir entre em contato com o suporte Orangiuz",
        icon: "error",
      });
    }
  }, [getCep, values.cep]);

  //Define o retorno da api nos valores dos campos
  React.useEffect(() => {
    if (!cepResponse) return;
    setValues((values) => ({
      ...values,
      rua: cepResponse.logradouro,
      bairro: cepResponse.bairro,
      cidade: cepResponse.localidade,
      uf: cepResponse.uf,
    }));
  }, [cepResponse, setValues]);

  const colunas = React.useMemo(() => {
    const baseColumns = [
      {
        Header: "Nome completo",
        accessor: "dependente_nome",
      },
      {
        Header: "CPF",
        accessor: (row) => {
          return Format.formataCPF(row.dependente_cpf);
        },
      },
      {
        Header: "Data nascimento",
        disableSortBy: true,
        accessor: (row) => {
          return formataData(row.dependente_nascimento);
        },
      },
      {
        Header: "Tipo dependente",
        disableSortBy: true,
        accessor: (row) => {
          return (
            (tiposDependente &&
              tiposDependente.find(
                (dependente) =>
                  parseInt(dependente.chave) === parseInt(row.dependente_tipo)
              )?.valor) ||
            ""
          );
        },
      },
    ];

    if (editavel) {
      baseColumns.push({
        Header: "Ações",
        disableSortBy: true,
        accessor: (row) => {
          var status = [];

          status.push(
            <DropdownButton
              onClick={() => {
                excluirDependente(row.id);
              }}
              color="danger"
              icon="mdi mdi-delete"
            >
              Excluir
            </DropdownButton>
          );

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      });
    }

    return baseColumns;
  }, [editavel, excluirDependente, tiposDependente]);

  return (
    <>
      <div className="row">
        <div className="col-lg-6 mb-3">
          <CommonInput
            id="nome"
            label="Nome completo"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.nome}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInputMask
            id="cpf"
            label="CPF"
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask="999.999.999-99"
            value={values.cpf}
            required
            disabled
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInput
            id="identidade"
            label="RG"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.identidade}
            disabled={!editavel}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 mb-3">
          <CommonInput
            id="orgao_expeditor"
            label="Órgão expedidor do RG"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.orgao_expeditor}
            disabled={!editavel}
            maxLength={5}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInputMask
            id="pis"
            label="Número do PIS"
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask="999.99999.99-9"
            value={values.pis}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInputDate
            id="data_nascimento"
            label="Data de nascimento"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.data_nascimento}
            required
            disabled={!editavel}
            max={hoje.toISOString().split("T")[0]}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonSelect
            id="sexo"
            label="Gênero"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.sexo}
            data={tiposGenero.map((genero) => ({
              text: genero.valor,
              id: genero.chave,
            }))}
            required
            disabled={!editavel}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 mb-3">
          <CommonSelect
            id="deficiencia"
            label="Deficiência"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.deficiencia}
            data={tiposDeficiencia.map((deficiencia) => ({
              text: deficiencia.valor,
              id: deficiencia.chave,
            }))}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonSelect
            id="estado_civil"
            label="Estado civil"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.estado_civil}
            data={tiposEstadoCivil.map((estadoCivil) => ({
              text: estadoCivil.valor,
              id: estadoCivil.chave,
            }))}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonSelect
            id="raca_cor"
            label="Raça/cor"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.raca_cor}
            data={tiposEtnia.map((etnia) => ({
              text: etnia.valor,
              id: etnia.chave,
            }))}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonSelect
            id="grau_instrucao"
            label="Escolaridade"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.grau_instrucao}
            data={tiposGrauInstrucao.map((grauInstrucao) => ({
              text: grauInstrucao.valor,
              id: grauInstrucao.chave,
            }))}
            required
            disabled={!editavel}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 mb-3">
          <CommonInputMask
            mask="99.999-999"
            label="CEP"
            id="cep"
            value={values.cep}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-5 mb-3">
          <CommonInput
            label="Logradouro"
            id="rua"
            value={values.rua}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="N°"
            id="numero"
            value={values.numero}
            onChange={(e) => handleChangeNumeral(e, values, setValues)}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInput
            label="Complemento"
            id="complemento"
            value={values.complemento}
            onChange={(e) => handleChange(e, values, setValues)}
            disabled={!editavel}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="Bairro"
            id="bairro"
            value={values.bairro}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInput
            label="Cidade"
            id="cidade"
            value={values.cidade}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            disabled
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="UF"
            id="uf"
            value={values.uf}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            disabled
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonSelect
            label="UF nascimento"
            id="uf_nascimento"
            value={values.uf_nascimento}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={
              estados &&
              Object.keys(estados).map((estadoKey) => ({
                text: estados[estadoKey].sigla,
                id: estados[estadoKey].sigla,
                "data-ufid": estados[estadoKey].id,
              }))
            }
            placeholder="Selecione o estado"
            required
            disabled={!editavel}
          />
        </div>
        {values.uf_nascimento !== "EX" && (
          <div className="col-lg-3 mb-3">
            <CommonSelect
              label="Cidade nascimento"
              id="cidade_nascimento"
              value={values.cidade_nascimento}
              onChange={(e) => handleChange(e, values, setValues)}
              data={
                municipios &&
                Object.keys(municipios).map((estadoKey) => ({
                  text: municipios[estadoKey].nome,
                  id: municipios[estadoKey].nome,
                }))
              }
              placeholder="Selecione uma cidade"
              required
              disabled={!editavel}
            />
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-lg-3 mb-3">
          <CommonInput
            id="email"
            label="E-mail"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.email}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInputMask
            id="celular"
            label="Celular"
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask="(99)9 9999-9999"
            value={values.celular}
            required
            disabled={!editavel}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonSelect
            id="nacionalidade"
            label="Nacionalidade"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.nacionalidade}
            data={tiposNacionalidade.map((nacionalidade) => ({
              text: nacionalidade.valor,
              id: nacionalidade.chave,
            }))}
            required
            disabled={!editavel}
          />
        </div>
        {values?.nacionalidade && values?.nacionalidade === "2" ? (
          <div className="col-lg-3 mb-3">
            <CommonInput
              label="Informe a nacionalidade"
              id="informe_nacionalidade"
              value={values.informe_nacionalidade}
              onChange={(e) => handleChange(e, values, setValues)}
              required
              disabled={!editavel}
            />
          </div>
        ) : null}
      </div>
      <div className="row">
        <div className="col mb-3">
          <CommonCheckboxSimNao
            id="dependentes"
            label="Dependentes?"
            value={values.dependentes}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
            disabled={!editavel}
          />
        </div>
      </div>
      {values?.dependentes ? (
        <>
          {editavel ? (
            <div className="row">
              <div className="col-lg-4 mb-3">
                <CommonInput
                  label="Nome completo"
                  id="nome_dependente"
                  value={values.nome_dependente}
                  onChange={(e) => handleChange(e, values, setValues)}
                  required
                />
              </div>
              <div className="col-lg-2 mb-3">
                <CommonInputMask
                  id="cpf_dependente"
                  label="CPF"
                  onChange={(e) => handleChange(e, values, setValues)}
                  mask="999.999.999-99"
                  value={values.cpf_dependente}
                  required
                />
              </div>
              <div className="col-lg-2 mb-3">
                <CommonInputDate
                  id="data_nascimento_dependente"
                  label="Data nascimento"
                  onChange={(e) => handleChange(e, values, setValues)}
                  value={values.data_nascimento_dependente}
                  required
                  max={hoje.toISOString().split("T")[0]}
                />
              </div>
              <div className="col-lg-2 mb-3">
                <CommonSelect
                  id="tipo_dependente"
                  label="Tipo dependente"
                  onChange={(e) => handleChange(e, values, setValues)}
                  value={values.tipo_dependente}
                  data={tiposDependente.map((dependente) => ({
                    text: dependente.valor,
                    id: dependente.chave,
                  }))}
                  placeholder="Selecione"
                  required
                />
              </div>
              <div className="col-md-2 mb-3" style={{ alignSelf: "end" }}>
                <CommonButton color="success" onClick={novoDependente}>
                  Incluir dependente
                </CommonButton>
              </div>
            </div>
          ) : null}
          <div className="row">
            <div className="col mb-3">
              <CommonDataTable colunas={colunas} linhas={dependentes} />
            </div>
          </div>
        </>
      ) : null}
      <div className="row mb-3 mx-0">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-end gap-1">
          <CommonButton onClick={retornar} color="danger">
            Voltar
          </CommonButton>
          {editavel ? (
            <CommonButton onClick={salvaColaborador} color="success">
              {admissao ? "Salvar rascunho" : "Salvar"}
            </CommonButton>
          ) : null}
          <CommonButton
            onClick={() => {
              TabHelper.trocarTab(tabAtual, setTabAtual, 1);
            }}
            color="primary"
          >
            Próximo
          </CommonButton>
        </div>
      </div>
    </>
  );
}

DadosPessoais.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  estados: PropTypes.object.isRequired,
  municipios: PropTypes.object.isRequired,
  cepApi: PropTypes.shape({
    getCep: PropTypes.func.isRequired,
    cepResponse: PropTypes.object,
  }).isRequired,
  dependentes: PropTypes.array.isRequired,
  tabHook: PropTypes.shape({
    tabAtual: PropTypes.string.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  salvaColaborador: PropTypes.func.isRequired,
  editavel: PropTypes.bool.isRequired,
  novoDependente: PropTypes.func.isRequired,
  excluirDependente: PropTypes.func.isRequired,
  retornar: PropTypes.func.isRequired,
  admissao: PropTypes.bool,
};

DadosPessoais.defaultProps = {
  admissao: false,
};

export default DadosPessoais;
